"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeSquareBracketAfterBegin = escapeSquareBracketAfterBegin;
function escapeSquareBracketAfterBegin(tex) {
    return tex.replace(/(\\begin{[^}]*}\s*)\[/g, "$1{}[");
}
